import { Fragment, useEffect, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { useAuth } from '~src/hooks/useAuth';
import { config } from '~config';
import { routes } from '~src/routes/routes';
import referAFriendImage from '../../assets/images/refer-a-friend.svg';
import { MegaphoneIcon } from '@heroicons/react/24/outline';
import CopyToClipboard from 'react-copy-to-clipboard';
import { Button } from '../Button';

export default function ReferralDropDown() {
  const { user, status } = useAuth();
  const [copied, setCopied] = useState(false);
  const [userClaim, setUserClaim] = useState({});
  const [referLink, setReferLink] = useState('');

  useEffect(() => {
    if (status === "signedIn") {
      user?.getIdTokenResult?.()
        .then((currentUserClaims) => setUserClaim(currentUserClaims.claims));
    }
  }, [status, user]);

  useEffect(() => {
    setReferLink(
      `${config.brand.referralLinkUrl}${routes.signup.path}?sponsor=${userClaim.memberNumber}`
    );
  }, [userClaim]);

  return (
    <div className="referral-menu" key="referral-menu">
      <Menu as="div" className="relative">
        <div>
          <Menu.Button className="flex max-w-xs items-center rounded-full text-sm text-giveGray-500 hover:text-giveGray-400 focus:outline-none focus:ring-2 focus:ring-brand-200 focus:ring-offset-2">
            <span className="sr-only">Open Refer A Friend Menu</span>
            <MegaphoneIcon className="h-4 w-4 md:h-6 md:w-6" />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute -right-24 md:-right-10 z-10 mt-4 w-80 md:w-[600px] origin-top-right rounded-md bg-white py-1 shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="py-2 px-4 border-b border-giveGray-200 border-solid flex flex-col md:flex-row items-center gap-4">
              <img
                className={'w-32'}
                src={referAFriendImage.src}
                alt="refer a friend"
              />
              <div className='flex flex-col justify-center'>
                <div className="font-semibold text-base md:text-lg">Refer a Friend</div>
                <span className='text-sm md:text-base'>
                    Invite your friends to join the Give Community and get rewarded for anyone
                    that joins and participates in the Blockchain actions!
                </span>
              </div>
            </div>
            <Menu.Item>
              {({ active }) => (
                <div className="m-4 flex flex-col md:flex-row gap-4">
                  <div className="w-full md:w-5/6 border border-solid border-giveGray-300 rounded-md flex justify-start items-center py-2 px-4">
                    <span className="text-sm md:text-base font-semibold text-gray-500 truncate">
                      {referLink}
                    </span>
                  </div>
                  <CopyToClipboard 
                    text={referLink}
                    onCopy={() => {
                        setCopied(true);
                        return false;
                      }}
                    >
                    <Button                      
                      width="w-full md:w-1/6"
                      onClick={(e) => e.preventDefault()}
                    >
                      {copied ? 'Copied!' : 'Copy'}
                    </Button>
                  </CopyToClipboard>
                </div>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
}
